export const CONTENT_TYPE = 'application/json;charset=UTF-8';
export const ACCEPT = 'application/json';
export const ERROR_TEXT = 'no valid attr';
